import { useId } from "react";
import cn from "classnames";

interface ToggleButtonProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
}

export default function ToggleButton({ checked, onChange, disabled = false, id }: ToggleButtonProps) {
  const generatedId = useId();
  const buttonId = id || generatedId;

  return (
    <button
      id={buttonId}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative inline-flex items-center w-[36px] h-5 shrink-0 rounded-full cursor-pointer transition-colors duration-200 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 focus-visible:ring-brand-200",
        checked ? "bg-brand-500 hover:bg-brand-600" : "bg-grey-300 hover:bg-grey-400",
        disabled && "opacity-40 cursor-not-allowed",
      )}>
      <span
        className={cn(
          "inline-block w-4 h-4 rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out",
          checked ? "translate-x-[18px]" : "translate-x-[2px]",
        )}
      />
    </button>
  );
}
